var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpensea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_81_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.4 0.500102C22.8 0.300102 0.300011 22.8001 0.500011 50.4001C0.700011 77.3001 22.7 99.2001 49.6 99.5001C77.3 99.7001 99.8 77.2001 99.5 49.6001C99.3 22.7001 77.3 0.700102 50.4 0.500102Z",
    fill: "#2081E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6 25.9001C38.7 29.8001 40.5 34.7001 40.5 40.1001C40.5 44.7001 39.1 49.0001 36.8 52.6001H20.2L35.6 25.9001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3 58.5C86.3 58.7 86.2 58.9 86 59C84.9 59.5 81.2 61.2001 79.6 63.4001C75.6 68.9001 72.6 77.7 65.8 77.7H37.3C27.2 77.7 18.8 69.7 18.9 59.1C18.9 58.8 19.1 58.6 19.4 58.6H32.8C33.3 58.6 33.6 59.0001 33.6 59.4001V62C33.6 63.4 34.7 64.5 36.1 64.5H46.3V58.6H39.3C43.3 53.5 45.7 47.1 45.7 40.1C45.7 32.3 42.7 25.2 37.8 19.9C40.8 20.2 43.6 20.8 46.2 21.6V19.9C46.2 18.2 47.6 16.8 49.3 16.8C51 16.8 52.4 18.2 52.4 19.9V23.9C61.9 28.3 68.2 35.7 68.2 44.1C68.2 49 66.1 53.6001 62.4 57.4001C61.7 58.1001 60.7 58.5 59.7 58.5H52.5V64.4001H61.5C63.4 64.4001 66.9 60.7 68.6 58.5C68.6 58.5 68.7 58.4 68.9 58.3C69.1 58.2 85.5 54.5 85.5 54.5C85.8 54.4 86.2 54.7 86.2 55L86.3 58.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_81_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpensea);
export default __webpack_public_path__ + "static/media/Opensea.7e2f74863f578e005aded69717d6ebc8.svg";
export { ForwardRef as ReactComponent };